export { Link as default } from 'lib/next-intl'
